// extracted by mini-css-extract-plugin
export default {"btnContainer":"SendQuoteToAll_btnContainer__DHpGV"};